import * as React from 'react';
import { Form } from 'react-final-form';
import Field from '../../SettingsForm/Field/Field';
import './AddCollection.css';
import BooksList from './BooksList/BooksList';
import { CardsManagerCallbacks } from '../../CardsManager/CardsManager';
import Button from '../../Button/Button';
import arrayMutator from 'final-form-arrays';
import { FORM_ERROR } from 'final-form';
import addCollection from '../../../requests/addCollection';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const AddCollection: React.FC<Props> = props => {
	const inititalValues = {
		name: '',
		description: '',
		books: [] as any
	};

	const onSubmit = async (values: any) => {
		const request = await addCollection({
			data: values
		});

		if (request) {
			window.location.href = `/collection/${request}`;
		}
	};

	return <div>
		<div className="addCollection__header">Создание новой коллекции</div>

		<div className="addCollection__section">
			<div className="addCollections-books__header">
				Основное
			</div>

			<Form mutators={{
				...arrayMutator
			}} initialValues={inititalValues} onSubmit={onSubmit}>
				{({ form, handleSubmit }) => {
					return <form onSubmit={handleSubmit}>
						<div className="addCollection__section">
							<Field
								name="name"
								type="text"
								label="Название коллекции"
							/>
						</div>

						<div className="addCollection__section">
							<Field
								name="description"
								type="text"
								label="Описание коллекции"
							/>
						</div>

						<div className="addCollections-books">
							<div className="addCollections-books__header">
								Управление книгами
							</div>

							<BooksList
								callbacks={props.callbacks}
							/>
						</div>

						<Button type="primary" onClick={() => handleSubmit()}>
							Сохранить
						</Button>
					</form>
				}}
			</Form>
		</div>
	</div>
};

export default AddCollection;
